
const { location } = require('window');

const Q = require('q');
const $ = require('jquery');
import ko from 'rgs-knockout';

const cookies = require('js-cookie');

const server = require('server');

const { profile } = require('myrgs-auth-helpers');

const cleanupCookies = require('../cleanup-cookies');

const Model = require('./model');
const initInsurancesCounter = require('./data-api-insurances-counter');
const initProlongationNotification = require('./prolongation-notification');


module.exports = function MyLeftMenuController () {
	const self = {};

	const modelOptions = {
		IsTemporaryPassword: 'true' === cookies.get('Rgs.My.Main.Auth.IsTemporaryPassword'),
		RsaCheckForOsagoMode: 'true' === cookies.get('Rgs.My.Main.RsaCheckForOsagoMode'),
		LogoutButtonClick: function () {
			Q.all([
				server.my.cmsapi.lk.logout(),
			]).spread(function () {
				cleanupCookies();
				location.pathname = '/';
			}).done();
		},
	};

	const model = self.model = new Model(modelOptions);

	profile.updateAtLeastOnce()
		.then(function (response) {
			const data = response.responseJSON;
			if (data.IsAuthenticated) {
				model.UserProfileServer.fromJS(data);
			}
		})
		.done();

	const leftMenu = $('#LeftMenu')[0];
	if (leftMenu) {
		ko.applyBindings(model, leftMenu);
	}

	self.SetProfileData = function (data) {
		model.UserProfileServer.fromJS(data);
	};

	initInsurancesCounter();
	initProlongationNotification();

	return self;
};


